import {
  combineReducers
} from "redux";
import { put, takeLatest } from "redux-saga/effects";
import bankSwap from "store/state/calculators/bankSwap";
import forwardCurve from "store/state/calculators/forwardCurve";
import cashFlows from "store/state/calculators/cashFlows";
import prepayment from "store/state/calculators/prepayment";
import capPricer from "store/state/calculators/capPricer";
import suppPricer from "store/state/calculators/suppPricer";

import { makePayload } from "../../utils/helpers";

// RESET_TEST_DATA
export const RESET_TEST_DATA = "RESET_TEST_DATA";
export const resetTestData = payload => makePayload(RESET_TEST_DATA, payload);
function* resetTestDataSaga() {
  yield put(RESET_TEST_DATA);
}

export function* testHarnessSaga() {
  yield takeLatest(RESET_TEST_DATA, resetTestDataSaga);
}

const calculatorReducer = combineReducers({
  forwardCurve,
  bankSwap,
  cashFlows,
  prepayment,
  capPricer,
  suppPricer
});

export default calculatorReducer;
